/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { humanCompare } from '@common/utils/human-compare';
import { Cluster3xTable } from '@shared/types/tables';

export const sortTablesByFullName = (tables: Cluster3xTable[]) =>
  [...tables].sort((a, b) => humanCompare(fullTableName(a), fullTableName(b)));

export const fullTableName = (table: Cluster3xTable) => `${table.schemaName}.${table.tableName}`.toUpperCase();

export const findTableByFullName = (tables: Cluster3xTable[], tableName: string) =>
  tables.find((it) => fullTableName(it).toLowerCase() === tableName.toLowerCase());
